<template>
    <div :class="[className]">
        <div class="BaseCheckbox" v-bind:class="{'BaseCheckbox_error':(errors && errors.length>0)}">
            <input v-bind:id="fieldName" type="checkbox" v-bind:checked="value" @change="change($event)">
            <label v-bind:for="fieldName">{{translate(label)}}</label> <a v-if="link" class="BaseCheckbox__link" :href="link" target="_blank">{{translate(linkLabel)}}</a>
        </div>
        <BaseErrors :errors="errors"/>
    </div>
</template>

<script>
    import BaseErrors from './BaseErrors.vue';

    export default {
        name: 'BaseCheckbox',
        components: {
            BaseErrors
        },
        props: {
            //Text near the checkbox
            label: {
                type: String,
                required: true
            },
            //Input checkbox value
            value: {
                type: Boolean,
                required: true
            },
            //Name of the field
            fieldName: {
                type: String,
                required: true
            },
            //Form validation errors
            errors: {
                type: Array
            },
            //Additional css class name for styling
            className: {
                type: String
            },
            //Text for additional link after checkbox text
            linkLabel: {
                type: String
            },
            //Url for additional link after checkbox text
            link: {
                type: String
            }
        },
        methods: {
            change: function (e) {
                this.$emit('change', e);
            }
        }
    };
</script>

<style>
    .BaseCheckbox {
        position: relative;
        height: 20px;
        margin: 16px 0 8px 0;
    }

        .BaseCheckbox label {
            cursor: pointer;
            vertical-align: top
        }

            .BaseCheckbox label:after, .BaseCheckbox label:before {
                content: "";
                position: absolute;
                left: 0;
                top: 0
            }

            .BaseCheckbox label:before {
                width: 20px;
                height: 20px;
                background: #fff;
                border: 2px solid #757575;
                border-radius: 2px;
                cursor: pointer;
                transition: background .3s
            }

    .BaseCheckbox__link {
        color: #00838F;
    }

    .BaseCheckbox input[type=checkbox] {
        outline: 0;
        margin-right: 10px
    }

        .BaseCheckbox input[type=checkbox]:checked + label:before {
            background: #00bcd4;
            border: none
        }

        .BaseCheckbox input[type=checkbox]:checked + label:after {
            -webkit-transform: rotate(-45deg);
            transform: rotate(-45deg);
            top: 5px;
            left: 4px;
            width: 12px;
            height: 6px;
            border: 2px solid #fff;
            border-top-style: none;
            border-right-style: none
        }

    .BaseCheckbox_error label {
        color: #cc4a4a
    }

        .BaseCheckbox_error label:before {
            border: 2px solid #cc4a4a
        }
</style>



// WEBPACK FOOTER //
// BaseCheckbox.vue?4fe3a498